import React, { useState, useEffect } from "react";
import { updateGenericIdea } from "../../../../../db/genericFiredataCalls";
import moment from "moment";
import {
  Row,
  Col,
  Spin,
  Button,
  Form,
  Input,
  Select,
  InputNumber,
  Alert,
  message,
  Radio,
} from "antd";
import "../../../../../App.css";
import "bootstrap/dist/css/bootstrap.min.css";
import { useTranslation } from "react-i18next";
import { PanelRender } from "../../../../CustomComponents/HEB/OTDPanel";

const { Option } = Select;
const GenericDetails = (props) => {
  const { t } = useTranslation();
  const [showBenefitType, setShowBenefitType] = useState();
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [displayError, setDisplayError] = useState("none");
  const [otherArea, setOtherArea] = useState(false);

  const Loader = () => (
    <div
      style={{
        height: "100vh",
        width: "100vw",
        textAlign: "center",
        marginTop: "25%",
      }}
    >
      <Spin size="large" spinning={true}></Spin>
    </div>
  );
  const onFinish = async (values) => {
    Object.entries(values).forEach(([k, v]) => {
      if (v === undefined) values[k] = null;
    });
    var localValues = values;
    //var periodicidadValor = 0;
    //var roi = 0;
    if (showBenefitType) {
      //Si es de tipo Beneficio
      //localValues.people = null;
      localValues.executionTime = null;
      //localValues.repetitive = null;
      /*
      periodicidadValor = 0;
      switch (localValues.periodicity) {
        case "diario":
          periodicidadValor = 240;
          break;
        case "semanal":
          periodicidadValor = 48;
          break;
        case "catorcena":
          periodicidadValor = 24;
          break;
        case "periodo":
          periodicidadValor = 12;
          break;
        case "anual":
          periodicidadValor = 1;
          break;
        default:
          break;
      }
      roi = periodicidadValor * localValues.benefit;
      //Cálculo del ROI en dinero
      localValues.estimatedROI = roi;*/
    } else {
      //Si es de tipo Tiempo
      localValues.benefit = null;
      /*
      periodicidadValor = 0;
      switch (localValues.periodicity) {
        case "diario":
          periodicidadValor = 20;
          break;
        case "semanal":
          periodicidadValor = 4;
          break;
        case "catorcena":
          periodicidadValor = 2;
          break;
        case "periodo":
          periodicidadValor = 1;
          break;
        default:
          break;
      }
      roi =
        periodicidadValor * localValues.executionTime * localValues.repetitive;
      //Cálculo del ROI en horas
      localValues.estimatedROI = roi;*/
    }
    if (!otherArea) {
      localValues.otherArea = null;
    }

    let user = {
      uid: props.userInfo.uid,
      firstName: props.userInfo.firstName,
      lastName1: props.userInfo.lastName1,
    };
    let _date = moment.utc();
    localValues.updatedDate = { seconds: _date.unix(), nanoseconds: 0 };
    localValues.history = props.idea.history ? props.idea.history : [];
    localValues.history.push({
      eventType: "MODIFIED",
      date: localValues.updatedDate,
      performer: user,
    });
    try {
      await updateGenericIdea(props.idea.id, localValues);
      setLoading(false);
      message.success();
    } catch (error) {
      setDisplayError("block");
    }
  };
  useEffect(() => {
    if (props.idea) {
      form.setFieldsValue({ ...props.idea });
      setShowBenefitType(props.idea.monthlyBenefit);
      if (props.idea.workCategory === "OTRO") {
        setOtherArea(true);
      }
    }
  }, [props.idea, form]);
  return props.loading ? (
    <Loader />
  ) : (
    <>
      <Row>
        <Form
          form={form}
          name="create-idea"
          onFinish={onFinish}
          labelCol={{
            span: 7,
          }}
          wrapperCol={{
            span: 17,
          }}
          layout="vertical"
          size="middle"
          style={{ width: "100%" }}
          labelAlign="right"
        >
          <Row gutter={6}>
            <Col span={24}>
              <Form.Item
                labelCol={2}
                wrapperCol={18}
                name="name"
                label={t("Generic.ProcessDetails.Text.Label.Name")}
                rules={[
                  {
                    required: true,
                    message: t(
                      "Generic.ProcessDetails.Text.Message.Error.Name"
                    ),
                  },
                ]}
              >
                <Input />
              </Form.Item>
            </Col>
            <Col span={24}>
              <Form.Item
                labelCol={2}
                wrapperCol={18}
                name="description"
                label={t("Generic.ProcessDetails.Text.Label.Description")}
                rules={[
                  {
                    required: true,
                    message: t(
                      "Generic.ProcessDetails.Text.Message.Error.Description"
                    ),
                  },
                ]}
              >
                <Input.TextArea />
              </Form.Item>
            </Col>
            <Col span={6}>
              <Form.Item
                labelCol={12}
                wrapperCol={18}
                name="team"
                label={t("Generic.ProcessDetails.Text.Label.Team")}
                rules={[
                  {
                    required: true,
                    message: t(
                      "Generic.ProcessDetails.Text.Message.Error.Team"
                    ),
                  },
                ]}
              >
                <Select
                  placeholder={t(
                    "Generic.ProcessDetails.Text.Placeholder.Team"
                  )}
                >
                  <Option value={"Provider"} key={"provider"}>
                    {t("Generic.ProcessDetails.Text.Value.Team.Provider")}
                  </Option>
                  <Option value={"Company"} key={"company"}>
                    {t("Generic.ProcessDetails.Text.Value.Team.Company")}
                  </Option>
                </Select>
              </Form.Item>
            </Col>
            {/**
             <Col span={12}>
              <Form.Item
                labelCol={12}
                wrapperCol={18}
                name="asigneeName"
                label={t("form_fields.create_idea_HEB.user.label")}
                rules={[
                  {
                    required: true,
                    message: t(
                      "form_fields.create_idea_HEB.user.error_message"
                    ),
                  },
                ]}
              >
                <Input
                  placeholder={t(
                    "form_fields.create_idea_HEB.user.placeholder"
                  )}
                />
              </Form.Item>
            </Col>
             */}

            <Col span={6}>
              <Form.Item
                labelCol={12}
                wrapperCol={18}
                label={t("Generic.ProcessDetails.Text.Label.WorkCategory")}
                name="workCategory"
                rules={[
                  {
                    required: true,
                    message: t(
                      "Generic.ProcessDetails.Text.Message.Error.WorkCategory"
                    ),
                  },
                ]}
              >
                <Select
                  placeholder={t(
                    "Generic.ProcessDetails.Text.Placeholder.WorkCategory"
                  )}
                  showSearch
                  optionFilterProp="children"
                  filterOption={(input, option) =>
                    option.name.toLowerCase().indexOf(input.toLowerCase()) >= 0
                  }
                  onChange={(value) => {
                    if (value === "OTRO") setOtherArea(true);
                    else setOtherArea(false);
                  }}
                >
                  {Object.entries(props.company.workCategories).map((areas) => {
                    return (
                      <Option value={areas[1]} key={areas[1]} name={areas[1]}>
                        {t(
                          "Generic.ProcessDetails.Text.Value.WorkCategory." +
                            areas[1]
                        )}
                      </Option>
                    );
                  })}
                </Select>
              </Form.Item>
            </Col>
            <Col span={6}>
              <Form.Item
                labelCol={12}
                wrapperCol={18}
                name="otherArea"
                label={t("Generic.ProcessDetails.Text.Label.OtherArea")}
                rules={[
                  {
                    required: otherArea,
                    message: t(
                      "Generic.ProcessDetails.Text.Message.Error.OtherArea"
                    ),
                  },
                ]}
              >
                <Input disabled={!otherArea} />
              </Form.Item>
            </Col>
            <Col span={4}>
              <Form.Item
                labelCol={12}
                wrapperCol={18}
                label={t("Generic.ProcessDetails.Text.Label.Priority")}
                name="priority"
                rules={[
                  {
                    required: true,
                    message: t(
                      "Generic.ProcessDetails.Text.Message.Error.Priority"
                    ),
                  },
                ]}
              >
                <InputNumber></InputNumber>
                {/* <Select style={{ width: "100%" }}>
                  <Option key="0" value={0}>
                    {"Muy Bajo"}
                  </Option>
                  <Option key="1" value={1}>
                    {"Bajo "}
                  </Option>
                  <Option key="2" value={2}>
                    {"Medio"}
                  </Option>
                  <Option key="3" value={3}>
                    {"Alto"}
                  </Option>
                  <Option key="4" value={4}>
                    {"Muy Alto"}
                  </Option>
                </Select> */}
              </Form.Item>
            </Col>
            <Col span={24}>
              <Form.Item
                colon={false}
                name="monthlyBenefit"
                labelAlign="left"
                label={t("Generic.ProcessDetails.Text.Label.MonthlyBenefit")}
                rules={[
                  {
                    required: true,
                    message: t(
                      "Generic.ProcessDetails.Text.Message.Error.MonthlyBenefit"
                    ),
                  },
                ]}
              >
                <Radio.Group
                  style={{ width: "100%" }}
                  onChange={(e) => setShowBenefitType(e.target.value)}
                >
                  <Radio.Button key="time" value={false}>
                    {t("Generic.ProcessDetails.Text.Value.MonthlyBenefit.Time")}
                  </Radio.Button>
                  <Radio.Button key="monetary" value={true}>
                    {t(
                      "Generic.ProcessDetails.Text.Value.MonthlyBenefit.Monetary"
                    )}
                  </Radio.Button>
                </Radio.Group>
              </Form.Item>
            </Col>
          </Row>

          <Row gutter={6} hidden={showBenefitType}>
            {/**
             <Col span={12}>
              <Form.Item
                labelCol={12}
                wrapperCol={8}
                label={t("form_fields.create_idea_HEB.people.label")}
                name="people"
                rules={[
                  {
                    required: !showBenefitType ? true : false,
                    message: t(
                      "form_fields.create_idea_HEB.people.error_message"
                    ),
                  },
                ]}
              >
                <InputNumber
                  style={{ width: "100%" }}
                  value={0}
                  min={0}
                  max={100}
                />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                labelCol={12}
                wrapperCol={8}
                label={t("form_fields.create_idea_HEB.periodicity.label")}
                name="periodicity"
                rules={[
                  {
                    required: !showBenefitType ? true : false,
                    message: t(
                      "form_fields.create_idea_HEB.periodicity.error_message"
                    ),
                  },
                ]}
              >
                <Select style={{ width: "100%" }}>
                  <Option key="0" value="diario">
                    {"Diario"}
                  </Option>
                  <Option key="2" value="semanal">
                    {"Semanal"}
                  </Option>
                  <Option key="3" value="catorcena">
                    {"Catorcena"}
                  </Option>
                  <Option key="4" value="periodo">
                    {"Periodo"}
                  </Option>
                </Select>
              </Form.Item>
            </Col>
             */}
            <Col span={12}>
              <Form.Item
                labelCol={12}
                wrapperCol={6}
                label={t("Generic.ProcessDetails.Text.Label.ExecutionTime")}
                name="executionTime"
                rules={[
                  {
                    required: !showBenefitType ? true : false,
                    message: t(
                      "Generic.ProcessDetails.Text.Message.Error.ExecutionTime"
                    ),
                  },
                ]}
              >
                <InputNumber
                  style={{ width: "100%" }}
                  defaultValue={0}
                  min={0}
                  max={100}
                />
              </Form.Item>
            </Col>
            {/**
             <Col span={12}>
              <Form.Item
                labelCol={12}
                wrapperCol={6}
                label={t("form_fields.create_idea_HEB.repetitive.label")}
                name="repetitive"
                rules={[
                  {
                    required: !showBenefitType ? true : false,
                    message: t(
                      "form_fields.create_idea_HEB.repetitive.error_message"
                    ),
                  },
                ]}
              >
                <InputNumber
                  style={{ width: "100%" }}
                  defaultValue={0}
                  min={0}
                  max={1000}
                />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                labelCol={12}
                wrapperCol={6}
                label={t("form_fields.create_idea_HEB.executorSalary.label")}
                name="executorHourSalary"
                rules={[
                  {
                    required: !showBenefitType ? true : false,
                    message: t(
                      "form_fields.create_idea_HEB.executorSalary.error_message"
                    ),
                  },
                ]}
              >
                <InputNumber
                  style={{ width: "100%" }}
                  defaultValue="0"
                  min={0}
                  placeholder={0}
                  formatter={(value) =>
                    `$ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                  }
                  parser={(value) => value.replace(/\$\s?|(,*)/g, "")}
                />
              </Form.Item>
            </Col>
             */}
          </Row>
          <Row gutter={6} hidden={!showBenefitType}>
            <Col span={12}>
              <Form.Item
                labelCol={12}
                wrapperCol={8}
                label={t("Generic.ProcessDetails.Text.Label.Benefit")}
                name="benefit"
                rules={[
                  {
                    required: showBenefitType ? true : false,
                    message: t(
                      "Generic.ProcessDetails.Text.Message.Error.Benefit"
                    ),
                  },
                ]}
              >
                <InputNumber
                  style={{ width: "100%" }}
                  defaultValue="0"
                  min={0}
                  placeholder={0}
                  formatter={(value) =>
                    `$ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                  }
                  parser={(value) => value.replace(/\$\s?|(,*)/g, "")}
                />
              </Form.Item>
            </Col>
            {/**}
            <Col span={12}>
              <Form.Item
                labelCol={12}
                wrapperCol={8}
                label={t("form_fields.create_idea_HEB.periodicity.label")}
                name="periodicity"
                rules={[
                  {
                    required: showBenefitType ? true : false,
                    message: t(
                      "form_fields.create_idea_HEB.periodicity.error_message"
                    ),
                  },
                ]}
              >
                <Select style={{ width: "100%" }}>
                  <Option key="0" value="diario">
                    {"Diario"}
                  </Option>
                  <Option key="2" value="semanal">
                    {"Semanal"}
                  </Option>
                  <Option key="3" value="catorcena">
                    {"Catorcena"}
                  </Option>
                  <Option key="4" value="periodo">
                    {"Periodo"}
                  </Option>
                  <Option key="5" value="anual">
                    {"Anual"}
                  </Option>
                </Select>
              </Form.Item>
            </Col>
             */}
          </Row>
          <Row gutter={6}>
            <Col span={12}>
              <br />
              <Form.Item>
                <Button
                  style={{ width: "100%", height: "32" }}
                  type="primary"
                  htmlType="submit"
                  loading={loading}
                >
                  {t("Generic.ProcessDetails.Button.Save")}
                </Button>
              </Form.Item>
            </Col>
            <Col span={3}>
              <br />
              <PanelRender
                ideas={[{ ...props.idea }]}
                userInfo={props.userInfo}
              ></PanelRender>
            </Col>
          </Row>
          <Row gutter={6}>
            <Col>
              <Alert
                message="Error"
                description={t(
                  "Generic.ProcessDetails.Text.Message.Error.NewProcess"
                )}
                type="error"
                closable
                style={{ display: displayError }}
              />
            </Col>
          </Row>
        </Form>
      </Row>
    </>
  );
};

export default GenericDetails;
